/** if you fix something here, edit the git repo, too */
const PRODUCTS_PER_AJAX = 100;
const COLLECTION_HANDLE_PLUS_SIZE = "plus-size"; // Plus size collection handle name

function rs_navigator(collection_name, PRODUCTS_PER_PAGE, PRODUCT_RENDERER, CUSTOM_FILTERS, CUSTOM_FILTERS_STRINGS) {
  // GLOBAL VARIABLES:
  var allProducts = {},     // all products in the collection/page
      sortParam = '';
  //rather than constantly querying these, set it and forget it
  var gparams = {
    page: 1,
    q: undefined,//might override these off the url
    filterOptions: undefined,
    sortBy: $("select#SortBy").val()
  };

//random functions
function splitParams(url) {
  if (!url) url = window.location.search;
  var parms= url.split('?'),
    out = [];
  if (parms.length != 2) {
    return out;
  }
  var a = parms[1].split('&');
  for (var i = 0; i < a.length; i++) {
    var _  = a[i].split('=');
    out[_[0]] = _[1];
  }
  return out;
}

function splitParamsA(url) {
  if (!url) url = window.location.search;
  var parms= url.split('?'),
    out = [];
  if (parms.length != 2) {
    return out;
  }
  var a = parms[1].split('&');
  for (var i = 0; i < a.length; i++) {
    var _  = a[i].split('=');
    if (out[_[0]]) {
      out[_[0]].push(_[1]);
    }else{
    out[_[0]] = [_[1]];
    }
  }
  return out;
}

function pushState() {
  var params = { }, needsparams = false;
  if (gparams != 1) {
    params.page = gparams.page;
    needsparams= 1;
  }
  if (gparams.q) {
    params.q = gparams.q;
    needsparams = 1;
  }
  var url = undefined;
  if (needsparams) {
    url = "?" + $.param(params);
  };
  history.pushState(
    {
      filterOptions: gparams.filterOptions
    },
    ' ',//title, ignored
    url
  );
}


//PAGINATION DIV

  function pagination_init() {
    $("#pagination").on('click', 'a',function (e) {
      e.preventDefault();
      var page = $(this).attr('title')
      if (page === '') {
        page = '999'
      }
      if (page !== '999') {
        page = parseInt(page);
        $("html, body").animate({ scrollTop: 0 }, 500);
      }
      if (page != gparams.page) {
        gparams.page = page;
        pushState();
      }
      paginateProducts(page);
    });
  }
  function setPaginator(currPage) {
    if (1 >= totalPages) {
      $('#pagination').html('');
      return;
    }
    var paginator = "";
    if (currPage !== '999') {
      paginator +=
      ((currPage - 1 >= 1) ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 1) + '" rel="prev" title="' + (currPage - 1) + '"><</a>' : '')
      + ((currPage !== 1) ? '<a href="/collections/' + collection_name + '?page=1" title="1">1</a>' : '' )
      + ((currPage >= 4) ? '…' : '')
      + ((currPage - 2 > 1) ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 2) + '" title="' + (currPage - 2) + '">' + (currPage - 2) + '</a>' : '' )
      + ((currPage - 1 > 1) ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 1) + '" title="' + (currPage - 1) + '">' + (currPage - 1) + '</a>' : '' )
      + '<span class="current">' + currPage + '</span>'
      + ((currPage + 1 < totalPages) ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 1) + '" title="' + (currPage + 1) + '">' + (currPage + 1) + '</a>' : '' )
      + ((currPage + 2 < totalPages) ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 2) + '" title="' + (currPage + 2) + '">' + (currPage + 2) + '</a>' : '' )
      + ((currPage <= totalPages - 4) ? '…' : '')
      + ((currPage !== totalPages) ? '<a href="/collections/' + collection_name + '?page=' + totalPages + '" title="' + totalPages + '">' + totalPages + '</a>' : '' )
      + ((currPage + 1 <= totalPages) ? '<a class="pagi_btn" href="/collections/' + collection_name + '?page=' + (currPage + 1) + '" rel="next" title="' + (currPage + 1) + '">></a>' : '');
    }
    paginator += '<a class="pagi_all" href="/collections/' + collection_name + '?page=' + (currPage === '999' ? "1" : '999' ) + '" title="' + (currPage === '999' ? "1" : '' ) + '">View ' + (currPage === '999' ? "less" : 'all' ) + '</a>';
    $('#pagination').html(paginator).show();
  }

  function getPage(page) {
    gparams.page = page;
    pushState();
    paginateProducts(page);
  }



// FILTERING

 function unsetFilterOption(ukey, uval) {
   if (gparams.filterOptions == undefined) return;
   $('.rs-and').each(function(k, andblock) {
    var key = $(this).data('tag') || $(this).find('ul').data('title');
    if (key != ukey) return;
    $(andblock).find('.rs-or').each(function(k, v) {
      if(gparams.filterOptions.indexOf($(this).data('tag') || $(this).text()) >= 0) {
        var val = $(this).data('tag') || $(this).text().toLowerCase().replace(',', '').replace(',', '');
        if (val != uval) return;
        $(this).removeClass('filter-selected')
        $(this).siblings('label').find('i').toggle();
        return false;
      }
    });
    if ($(andblock).find('.rs-range').length > 0) {
      var explode = gparams.filterOptions[0].split('-');
      if (explode[0].length > 0) $(andblock).find('.rs-or-min').val('');
      if (explode[1].length > 0) $(andblock).find('.rs-or-max').val('');
    }
   });
 }

 function unsetFilterItem(ukey, uval) {
   if (gparams.filterOptions == undefined) return;
   $('.rs-and').each(function(k, andblock) {
    var key = $(this).data('tag') || $(this).find('ul').data('title');
    if (key != ukey) return;
    $(andblock).find('.rs-or').each(function(k, v) {
      var item = $(this).data('tag') || $(this).data('type') || $(this).text();
      if ( item ) {
        item = item.trim().toLowerCase().replace(',', '').replace(',', '');
        if(gparams.filterOptions[ ukey ] && gparams.filterOptions[ ukey ].indexOf( item ) >= 0) {
          if (item != uval) return;
          $(this).removeClass('filter-selected')
          $(this).siblings('label').find('i').toggle();
          return false;
        }
      } else {
        return;
      }
    });
    if ($(andblock).find('.rs-range').length > 0) {
      var explode = gparams.filterOptions[0].split('-');
      if (explode[0].length > 0) $(andblock).find('.rs-or-min').val('');
      if (explode[1].length > 0) $(andblock).find('.rs-or-max').val('');
    }
   });
 }

function setFilterOptions(options) {
  // sort by:
  if(options.sortBy) {
    $('select#SortBy').val(options.sortBy);
  }
  if (options.filterOptions == undefined) return;
  // filter options:
  $('.rs-and').each(function(k, andblock) {
    var key = $(this).data('tag') || $(this).find('ul').data('title');
    var andOptions = options.filterOptions[key];
    if (andOptions && andOptions.length) {

      $(andblock).find('.rs-or').each(function(k, v) {
        if(andOptions.indexOf($(this).data('tag') || $(this).text().trim().toLowerCase()) >= 0) {
          $(this).addClass('filter-selected')
        }
      });
      if ($(andblock).find('.rs-range').length > 0) {
        var explode = andOptions[0].split('-');
        //this assumes there's only 1 range in the block. Nobody else does.
        //Should match the options array with -range array
        if (explode[0].length > 0) $(andblock).find('.rs-or-min').val(explode[0]);
        if (explode[1].length > 0) $(andblock).find('.rs-or-max').val(explode[1]);
      }
    }
  })
  filtershown(options.filterOptions);
}

  /** helper function for pFilter */
  function basicSearch(ortags, classes) {
    var or = false;
    $.each(typeof ortags == 'object' ? ortags : [ortags], function (i, tag) {
      if (classes.indexOf(tag) > -1) {
        or = true;
        return false;
      }
    });
    return or;
  };
 /** helper function for pFilter*/
 function basicTagSearch(ortags, object) {
   return object.tags ? basicSearch(ortags, object.tags) : false;
 }
  function pFilter(filters, object){
      CUSTOM_FILTERS["types"] = function(ortags, object) {
        return ortags.indexOf(object.type.toLowerCase()) >= 0;
      };
    var and = true;
    $.each(filters, function (i, ortags) {
      if(ortags && ortags.length) {
        and = and && (CUSTOM_FILTERS[i]||basicTagSearch)(ortags, object);
      }
    });
    return and;
  }

/**
limit the visible options to the ones that actually produce data.
*/
function restrictFilterOptions() {
  function prodSearched(key, val) {
    //return true as soon as you find a match
    for (var x = 0; x < allProducts.length; x++) {
      if ((CUSTOM_FILTERS[key]||basicTagSearch)([val], allProducts[x])) {
        //better? create one array of all the basic tag searches and do the loop once.
        return false;
      }
    }
    return true;
  }
  $('.rs-and').each(function(k, andblock) {
    var key = $(this).data('tag') || $(this).find('ul').data('title');
    $(andblock).find('.rs-or').each(function(k, v) {
      if(prodSearched(key, $(v).data('tag') || $(v).text().trim().toLocaleLowerCase())) {
        $(v).remove();//was hide, is individually showing items?
      }
    });
    //if ($(andblock).find('.rs-range').length > 0) {}
    //set the min/max on a slider?
  })
}

/**
 * Dispatch Event for IE11 fix
 * @param eventName
 */
function dispatchEvent(eventName) {
    var event = document.createEvent("CustomEvent");
    event.initEvent(eventName, false, true);
    document.dispatchEvent(event);
}

(function() {
    if (typeof window.Event === 'function') return false; //If not IE

    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined,
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(
            event,
            params.bubbles,
            params.cancelable,
            params.detail
        );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.Event = CustomEvent;
})();

// HISTORY STATE

 // do this on mobile only
 if(screen.width < 1025 ){
  // toggle side filters:
  $('#rs-filtermenu').find('.fa-minus-circle').not(":eq(0)").css('display','none');
  $('#rs-filtermenu').find('.fa-plus-circle').not(":eq(0)").css('display','inline-block');
  $('#rs-filtermenu').find('.fa-plus-circle').first().css('display','none');
  // $('#rs-filtermenu .filter-item').css('display','none');
  $('#rs-filtermenu .filter-item').css('display','block');
  $('.accordion-holder').first().toggleClass('open');
 } else {
  $('#rs-filtermenu').find('.fa-minus-circle').css('display','none');
 }

 $('#rs-filtermenu').on('click', '.accordion-side-menu-sub > label,.accordion-side-menu-sub .close_button', function() {
   $('#rs-filtermenu .accordion-holder').not($(this).parent().parent('.accordion-holder')).removeClass('open');

   $('#rs-filtermenu .accordion-holder').find('i.fa-minus-circle').not($(this).find('i')).hide();
   $('#rs-filtermenu .accordion-holder').find('i.fa-plus-circle').not($(this).find('i')).show();

   $(this).parent().parent('.accordion-holder').toggleClass('open'); //added this to make transition of filters smoother
   $(this).find('i').toggle();
   $(this).siblings('.clearall').toggleClass('open');
 })

 $('#rs-filtermenu').on('click', '.accordion-side-menu-sub', function() {
   $(this).siblings('li').slideToggle();
 })

 $('#rs-filtermenu').on('click', '.filter-item', function() {
   $(this).toggleClass('filter-selected');
        dispatchEvent("rs-filter.change");
     const page = getParameterByName("page")
     const products = filterProducts(allProducts);
     if (products.length > 0 && page === '999') {
         setPaginator(page)
         paginateProducts(page);
     }
 })
 // reset filters:
 $('#rs-filtermenu').on('click', '.clearall', function() {
     if ($(this).siblings('.items__filter_container').length > 0) {
        $(this).siblings('.items__filter_container').children('.filter-selected').removeClass('filter-selected');
      } else {
        $(this).siblings('.filter-selected').removeClass('filter-selected');
      }
    dispatchEvent("rs-filter.change");
 })
 $('#filtershown').on('click', '.clear-filter-item', function(){
      unsetFilterItem($(this).data('block'),$(this).data('tag'));
      dispatchEvent("rs-filter.change");
 });
 $('#rs-filtermenu').on('click', '.rs-change-filter', function(){
        dispatchEvent("rs-filter.change");
 });
 $('#filtershown').on('click','#rs-clearall', function(){
   $('.filter-selected').removeClass('filter-selected');
   $('.rs-range input').val('');
    dispatchEvent("rs-filter.change");
 });

var filterProducts = function(data) {
  var output  = [],
      filters = gparams.filterOptions;
  if (filters && Object.keys(filters).length) {
    for (var i = 0; i < data.length; i++) {
      if (pFilter(filters, data[i])) {
        output.push(data[i]);
      }
    }
  } else {
    output = data.slice(0,data.length); 
  }
  //EVENTUALLY: use gparams.q to further reduce output.
  //Would need to be nearly as useful as the built-in search, but would allow for better cached data.
  //Might also be able to: search by price ranges, variants without tags (does shopify do that?)
  return output;
}



//PRODUCTS

function product_init() {
  $('#product-loop').on('click', '.grid__item a', function() {
    //save the div id as the scroll state, instead of the pixels
    history.state.scrollTo = $(this).closest('.grid__item').attr('id');
    history.replaceStace(history.state);//TEST: that the div works the same as the scrollTop()
  });
  $('select#SortBy').on('change', function(){
    gparams.sortBy = $(this).val();
    paginateProducts(gparams.page);
  });
}
function product_sort(products) {
  var sortf = 0;
  if (gparams.sortBy == 'title-descending')
    sortf = function (b,a) { return a.title.localeCompare(b.title)}
  else if (gparams.sortBy == 'title-ascending')
    sortf = function (a,b) { return a.title.localeCompare(b.title)}
  else if (gparams.sortBy == 'price-ascending')
    sortf = function (a,b) { return a.price - b.price}
  else if (gparams.sortBy == 'price-descending')
    sortf = function (b,a) { return a.price - b.price}
  else if (gparams.sortBy == 'created-ascending')
    sortf = function (a,b) { return a.created_at > b.created_at}
  else if (gparams.sortBy == 'created-descending')
    sortf = function (b,a) { return (a.created_at > b.created_at ? 1 : (a.created_at == b.created_at ? a.title.localeCompare(b.title) : -1))}
  if (sortf)
    products.sort(sortf)
}

function getDuplicateProducts(products) {
    var productTitles = [];
    var duplicateTitles = [];
    products.forEach(function (product) {
        if (productTitles.indexOf(product.title) < 0) {
            productTitles.push(product.title);
        } else if (duplicateTitles.indexOf(product.title) < 0) {
            duplicateTitles.push(product.title);
        }
    });

    var duplicateProducts = [];
    products.forEach(function (product) {
        if (duplicateTitles.indexOf(product.title) >= 0) {
            duplicateProducts.push(product);
        }
    });

    duplicateProducts = duplicateProducts.sort(function compare(a, b) {
        return a.price - b.price;
    }).reverse();

    var duplicateProductsList = [];
    duplicateProducts.forEach(function (duplicateProduct) {
        if (duplicateProduct.handle.indexOf("-plus-size") < 0) {
            duplicateProductsList[duplicateProduct.title] = duplicateProduct;
        }
    });

    return duplicateProductsList;
}

// To get the plus size removed products list
function getNonPlusSizeProducts(products){
    var nonPlusSizeProducts = [];
    products.forEach(function (product) {
        if(product.tags.indexOf("plus size") < 0 ){
            nonPlusSizeProducts.push(product)
        }
    });
    return nonPlusSizeProducts;
}

function paginateProducts (page) {
  var collectionName = location.pathname.split("/").pop(); // To get the collection name
  var selectedPlusSizeFiltersLength = $(".plus-size-filter.filter-selected").length;
  products = filterProducts(allProducts);
  var duplicateProducts = getDuplicateProducts(products);
  product_sort(products);
	var lastTitle = [];
	var productCollections = [];
	products.forEach(function (product) {
		if (lastTitle.indexOf(product.title) < 0) {
			lastTitle.push(product.title);
			productCollections.push(duplicateProducts[product.title] ? duplicateProducts[product.title] : product);
		}
	});
	products = productCollections;
    product_sort(products);

    // To show the plus size products only when plus size category is selected or plus size filter is applied
  //     if(!collectionName.includes(COLLECTION_HANDLE_PLUS_SIZE) && selectedPlusSizeFiltersLength === 0){
    if(collectionName && !collectionName.includes(COLLECTION_HANDLE_PLUS_SIZE) && selectedPlusSizeFiltersLength === 0){
        products = getNonPlusSizeProducts(products);
    }


  totalPages = Math.ceil(products.length / PRODUCTS_PER_PAGE);
  $("#num-products").html("("+products.length+") items");
  if (!page) {
    page = getParameterByName("page") ? parseInt(getParameterByName("page"), 10) : 1;
  }

  if (products.length > 0 && page) {

    if (page !== '999' && page > totalPages) {
      page = 1;
    }
    var endNdx = ( (products.length < (page * PRODUCTS_PER_PAGE)) || (page === '999') ) ? products.length : page * PRODUCTS_PER_PAGE;//is either all available products, or a single page
    var productGrid = "";
    var startIdx = (page === '999' || (endNdx < PRODUCTS_PER_PAGE)) ? 0 : (page - 1) * PRODUCTS_PER_PAGE;//is either 0, or the start of the page
    for (var i=startIdx; i < endNdx; i++ ) {
      productGrid += PRODUCT_RENDERER.renderProduct(i, products[i]);
    }
    // render HTML
    $('#rs-notfound').hide();
    $("#product-loop").html(productGrid).removeClass('no-results').show();
    setPaginator(page);
  } else {
    $('#rs-notfound').show();
    $('#pagination').hide();
    $("#product-loop").hide();
  }
    dispatchEvent("rs-navigator.paginator");
}


document.addEventListener('rs-filter.change', function() {
  gparams.filterOptions = fillFilter();
  filtershown(gparams.filterOptions);
  gparams.page = 1;
  //replace state for each filter change?
  //also, the original version did not reset the page number
  paginateProducts(gparams.page);
});

function filtershown(filterOptions) {
 //generate another list of shows filters
 if ($('#filtershown').length === 0) {
   return
 }
  $('#filtershown').html('');
  var defaultString = function(ortag) {
    return ortag;
  }
   $.each(filterOptions, function (key, ortags) {
     var _ = CUSTOM_FILTERS_STRINGS[key] || defaultString;
     $.each(ortags, function(i,ortag) {

       $('#filtershown').append('<li class="clear-filter-item" data-block="'+key+'" data-tag="'+
                                ortag+'"><a>'+
        _(ortag)+'</a><span class="ion-close-round"></span></li>');
     });
   });
   if ($('#filtershown li').length > 0 ){
     if ($('#filtershown .clearall').length === 0 ) {
      $('#filtershown').append('<button type="reset" id="rs-clearall" class="rs__clearall">CLEAR ALL</button>');
     }
   } else {
    $('#filtershown .rs__clearall').remove();
   }

}

  function etag($this) {
    return $this.data('tag') || $this.text().toLowerCase().replace(',', '').replace(',', '').trim()
  }

function fillFilter(){
  var andtags = {};
  $('#rs-filtermenu').find('.rs-and').each(function (i, andblock){
    var ora = [];
    $(andblock).find('.rs-or.filter-selected').each(function(i, orb) {
      ora.push(etag($(this)));
    })
    $(andblock).find('.rs-range').each(function(i, orb) {
      var min = $(orb).find('.rs-or-min').val();
      var max = $(orb).find('.rs-or-max').val();
      if (min != '' || max != '') {
      ora.push(min+'-'+max);
      }
    })
    if (ora.length) andtags[$(andblock).data('tag') || $(andblock).find('ul').data('title')] = ora;
  });
  return andtags;
}

function pageInit() {

  if (PRODUCT_RENDERER.filterProduct) {
    var tmp = [];
	$.each(allProducts, function (i,o){
      if (PRODUCT_RENDERER.filterProduct(o)) {
        tmp.push(o);
      }
    });
    allProducts = tmp;
  }

  setFilterOptions(gparams);
  paginateProducts(gparams.page);

  if (history.state && history.state.scrollTo) {
    var $scroll = $('#'+history.state.scrollTo);
    if ($scroll.length == 1) {
      //$('#product-loop').imagesLoaded().done( function( instance ) {
        $('html, body').animate({ scrollTop: $scroll.offset().top }, 700);
      //});
    }
  }

  restrictFilterOptions();
}



function finishAjax() {
  if(collection_name === "search") {
    $('body').addClass('template-collection');
  }
  pagination_init();
  product_init();
  pageInit();
  renderTypes();

  $("#num-products").html("("+allProducts.length+") items");

  $('#ajaxLoader').hide();

    dispatchEvent("rs-navigator.finishAjax");
}

    function renderTypes() {
          const types = [];
        allProducts.forEach(function(allProduct) {
          if (types.indexOf(allProduct.type) < 0) {
            types.push(allProduct.type);
          }
        });
        var typesHtml = "";
        types.forEach(function (type) {
            if (type) {
                typesHtml += '<li class="rs-or filter-item" data-type="' + type + '">';
                typesHtml += '<svg class="checkbox-checked" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><rect x="0" y="0" width="15" height="15" fill="#504c6b" /></svg>';
                typesHtml += '<svg class="checkbox" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M22 2v20h-20v-20h20zm2-2h-24v24h24v-24z"/></svg>';
                typesHtml += '<a>' + type + '</a>';
                typesHtml += '</li>';
            }
        });
        $(".typesList").html(typesHtml);
        }


function loadDataAsset(url) {
  $.get(url,function(data) {
      allProducts = JSON.parse(data);
      finishAjax();
  })
}

function loadDataJSON(productsCount, search_terms) {

  var pagesCount = Math.ceil(productsCount / PRODUCTS_PER_AJAX),
  search = '',
  //PROGRAMMER: pick one of these
  //view = "view=metafields&page=";//includes metadata
  view = "view=json&page=";//slightly simpler

    if (view.indexOf("page=1")) {
        if (!(performance.navigation.type === 2)) {
            history.pushState({}, "?page=1");
        }
    }

  if (search_terms) {
    search = 'view=json&q='+ escape(search_terms) + '&type=product&'
  }

  var baseUrl = location.pathname + '?' + search + view;


    allProducts = new Array();
    totalPages = Math.ceil(productsCount / PRODUCTS_PER_PAGE);

  //INIT VIA AJAX:
  var requests = [];

  for (var i = 1; i<= pagesCount; i++) {
    requests.push(
      $.get(baseUrl + i + sortParam, function(data) {
        var currentPage = getParameterByName("page", this.url);
        var items = JSON.parse(data);
        for (var j = 0; j < items.length; j++) {
          allProducts[((currentPage - 1) * PRODUCTS_PER_AJAX) + j] = items[j];
        }
      })
    );
  }

  $.when.apply($, requests).done(function() {
   allProducts = allProducts.filter(function(v, i) {
      return v ? v : null;
    });
    finishAjax();
  });
}


window.addEventListener('popstate', function(e) {
  //popstate does not trigger on initial page load
  if(e.state) {
    console.log(e);
    gparams = e.state;
    pageInit();
  }
});



//init has available to it only the variables passed in, and the page url
// should not actually do anything

function navinit() {
  var ps = splitParams();
  if (ps.q) {
    gparams.q = ps.q
  }
  if (ps.pg) {
    gparams.page = parseInt(ps.pg)
  }
  if (ps.page) {
    gparams.page = parseInt(ps.page)
  }
  //get the tags off the url? Will be in the setFilter/popstate, but would be nice for a reload
  var psa = splitParamsA();
  if (psa) {
    setFilterOptions({filterOptions:psa});
    gparams.filterOptions = fillFilter();
  }
}

navinit();
  return {
'loadDirectly':function(products, current_page) {
  allProducts = products;
  gparams.page = current_page

  //render 1 page, assuming liquid did all filtering.
  //don't worry about setting the selected filters here.
  //Do not override the anchors, let it go back to Shopify
  //TODO: set the pagition anchors to grab the JSON out of the page render.
  // reset allProducts, the page number, then re-render. Faster than re-loading the entire page.
}
,
'loadRemotely':function(src, asset_url, total_products, search_count, search_terms) {
  $('#ajaxLoader').show();
  //start the load the data from the url(s)
  //Init the anchor overrides
  if (src === 'json') {
    loadDataJSON(total_products||search_count, search_terms)
  } else {
    loadDataAsset(asset_url)
  }
}
,
'setFiltering':function(tags, search){
  if (tags) gparams.filterOptions = tags;
  //FO is an array (and-level) of arrays (or-level) of items. Tags is an array of strings, but it is smart enough to figure that out.
  gparams.q = search;

  setFilterOptions(gparams);

  filtershown(gparams.filterOptions);
  //if we have any data, render it immediately.
  if (allProducts.length) {
    pageInit();
  }
  //else ajaxFinish will get to it eventually
}
,
'setView': function (all) {
  if (all) {
    gparams.page = '999';
  } else {
    gparams.page = 1;
  }
  paginateProducts(gparams.page);
}
  }
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
